/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
/* eslint-disable max-len */
import React, { useEffect } from 'react'
import {useContext ,useState} from "react"
import GlobalContext from '../../../components/Context/GloablContext'
import Pagination from '../../../components/Pagination'
import Limit from '../../../components/Limit'
import CustomOverLay from '../../../components/CustomOverLay'
import SearchEmptyScreen from '../../../components/SearchEmptyScreen'
import BloodGlouseVitalTable from './Table'
import Emptyscreenwithouttitle from '../../../components/Emptyscreenwithouttitle'
import { Link, useSearchParams,useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useDeviceAlertAcknowledgeMutation } from '../../../slices/alertSlice'
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import Loader from '../../../components/Loader'
import { useVitalReadingListQuery ,useGetHelpGuideProviderQuery} from '../../../slices/patientSlice'
import HelpGuideModal from '../../../components/HelpGuideModal'
import { handleSidebarPrvState } from '../../../redux/systemConfigSlice'
import DeviceAlertDashboardSearch from './AdvancedSearch'
import {setDeviceAlertDashboardSearchApplied } from '../../../redux/deviceAleartDashboardSlice';

export default function DeviceAlertList({wellnessDetails,wellnessFetching, setIsStateLoading}) {
    const [acknowledge] = useDeviceAlertAcknowledgeMutation()
    const [searchParams,setSearchParams] = useSearchParams()
    const [loading, setLoading] = useState(false)
    const [datePartialFilled,setDatePartialFilled]=useState(false)
    const location = useLocation();
    const deviceDashboardSearch = useSelector(state => state.deviceAlertDashboardSearchData);
    
    // Remove 'tabname' from searchParams and append the required keys for the API call
    const getFilteredSearchParams = () => {
        const filteredParams = new URLSearchParams(searchParams);
        filteredParams.delete("tabname"); // Remove 'tabname'
        return filteredParams.toString(); // Return the updated searchParams as a string
    };

    const { data, isFetching, status, refetch } = useVitalReadingListQuery(
        getFilteredSearchParams(), // Pass filtered searchParams to the API call
        {
            skip: searchParams.size < 6, 
            refetchOnMountOrArgChange: true,
        }
    );

    const dispatch = useDispatch()
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const [acknowledgeModal, setAcknowledgeModal] = useState(false)
    const [selectedAlert, setSelectedAlert] = useState({})
    const {isSideBar,setToastmessage,setToastErrorMessage, setIsSearchOpen, isSearchOpen, setIsSideBar} = useContext(GlobalContext);
    const [limit,setLimit]=useState("15")
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
    const [isSortselected,setisSortSelected]=useState(false)
    const reading_count=!wellnessFetching&&wellnessDetails?.patientData?.vital_reading_count ==='-';

      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideProviderQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    function handleNoOfRowsClick(number) {
        setSearchParams((prevParams) => ({
            ...Object.fromEntries(prevParams),
            page_number: 1,
            limit: number,
        }));
    }
    
    const handleOnClickPageNumber = (pageNum) => {
        setSearchParams((prevParams) => ({
            ...Object.fromEntries(prevParams),
            page_number: pageNum,
        }));
    };
    
    useEffect(() => {
        const patientId = location.pathname.split('/')?.[4];
    
        setSearchParams((prevParams) => {
            const params = Object.fromEntries(prevParams);
            if (params.patient_id) return prevParams; // Don't reset if already set
    
            return {
                ...params,
                limit: params.limit || '15',
                page_number: params.page_number || '1',
                reading_type: params.reading_type || 'all',
                type: params.type || 'alerts',
                patient_id: patientId,
            };
        });
    }, [location.pathname, setSearchParams]);
    
    

    useEffect(() => {
        const isManageDashboard = location?.pathname?.includes('manage-dashboard');
    
        if (userType === 'monitor-user') {
            setQueryParamsorg(isManageDashboard ? 'type=monitor-dashboard-device-alerts' : 'type=monitor-device-alerts');
        } 
    }, [userType, location]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setAcknowledgeModal(false)
    }

    const handleAcknowlegde = (item) => {
        setSelectedAlert(item)
        setAcknowledgeModal(true)
    }

    const handleFinalAcknowledge = async () => {
        setLoading(true)
        const response = await acknowledge(selectedAlert._id)
        if(response?.data){
            setToastmessage(`Alert acknowledged successfully`);
            setAcknowledgeModal(false)
            refetch()
            setLoading(false)
        } else {
            setToastErrorMessage(response?.error?.data?.message);
            setAcknowledgeModal(false)
            setLoading(false)
        }
    }

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        dispatch(handleSidebarPrvState(isSideBar));
        setIsSearchOpen(true);
        setIsSideBar(false);
    };

    // apply search function
    const handleOnSubmit = (e) => {
        
        e.preventDefault();
    
        let searchString = '';
        
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `device_id` and `device_id_inverse` conditions
        if (deviceDashboardSearch?.device_id && deviceDashboardSearch.device_id.trim() !== '') {
            const deviceIdPrefix = deviceDashboardSearch.device_id_inverse ? 'ne:' : '';
            const formattedDeviceId = formatSearchValue(deviceDashboardSearch.device_id);
            searchString += `device_id=${deviceIdPrefix}${encodeURIComponent(formattedDeviceId)};`;
        }

        // Check for `threshold` and `threshold_inverse` conditions
        if (deviceDashboardSearch?.threshold && deviceDashboardSearch.threshold.trim() !== '') {
            const thresholdPrefix = deviceDashboardSearch.threshold_inverse ? 'ne:' : '';
            const formattedThreshold = formatSearchValue(deviceDashboardSearch.threshold);
            searchString += `threshold=${thresholdPrefix}${encodeURIComponent(formattedThreshold)};`;
        }

        // Check for `reading` and `reading_inverse` conditions
        if (deviceDashboardSearch?.reading && deviceDashboardSearch.reading.trim() !== '') {
            const readingsPrefix = deviceDashboardSearch.reading_inverse ? 'ne:' : '';
            const formattedReadings = formatSearchValue(deviceDashboardSearch.reading);
            searchString += `reading=${readingsPrefix}${encodeURIComponent(formattedReadings)};`;
        }

        // check for alert_type field
        if (deviceDashboardSearch?.alert_type) {
            const alertTypePrefix = deviceDashboardSearch.alert_type_inverse ? 'ne:' : '';
            const formattedAlertType = formatSearchValue(deviceDashboardSearch.alert_type);
            searchString += `alert_type=${alertTypePrefix}${encodeURIComponent(formattedAlertType)};`;
        }

        // check for reading_type field
        if (deviceDashboardSearch?.reading_type) {
            const readingTypePrefix = deviceDashboardSearch.reading_type_inverse ? 'ne:' : '';
            const formattedReadingType = formatSearchValue(deviceDashboardSearch.reading_type)
                .toLowerCase() 
                .replace(/\s+/g, '_');
            searchString += `reading_type=${readingTypePrefix}${encodeURIComponent(formattedReadingType)};`;
        }

        // check for reading_details field
        if (deviceDashboardSearch?.reading_details) {
            const readingDetailsPrefix = deviceDashboardSearch.reading_details_inverse ? 'ne:' : '';
            const formattedReadingDetails = formatSearchValue(deviceDashboardSearch.reading_details);
            searchString += `reading_details=${readingDetailsPrefix}${encodeURIComponent(formattedReadingDetails)};`;
        }

        const { measurement_day, measurement_month, measurement_year } = deviceDashboardSearch || {};

        // Check if only some of the fields are filled
        const isPartialDateFilled =
        (measurement_day && (!measurement_month || !measurement_year)) ||
        (measurement_month && (!measurement_day || !measurement_year)) ||
        (measurement_year && (!measurement_day || !measurement_month));

        if (isPartialDateFilled) {
            setDatePartialFilled(true);
            return;
        } else if (
            measurement_day === '--' &&
            measurement_month === '--' &&
            measurement_year === '----'
        ) {
            // All fields contain dashes, send __NULL__
            const measurementDatePrefix = deviceDashboardSearch.measurement_date_inverse ? 'ne:' : '';
            searchString += `day_in_timezone=${measurementDatePrefix}__NULL__;`;
        } else if (measurement_day && measurement_month && measurement_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${measurement_year}-${String(measurement_month).padStart(2, '0')}-${String(measurement_day).padStart(2, '0')}`;
    
            // Add epoch to search string (or process it as needed)
            const measurementDatePrefix = deviceDashboardSearch.measurement_date_inverse ? 'ne:' : '';
            searchString += `day_in_timezone=${measurementDatePrefix}${dateStr};`;
        }
        // Remove trailing ';' if present
        if(deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__') && !deviceDashboardSearch?.acknowledged_id.includes('__NULL__') && deviceDashboardSearch.acknowledged_id_inverse === "true") {   
            searchString += `acknowledged_by=__NULL__`
        }else if(deviceDashboardSearch?.acknowledged_id.includes('__NULL__') && !deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__') && deviceDashboardSearch.acknowledged_id_inverse === "true") {
            searchString += `acknowledged_by=ne:__NULL__`
        }else if(deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__') && !deviceDashboardSearch?.acknowledged_id.includes('__NULL__')) {
            searchString += `acknowledged_by=ne:__NULL__`
        }else if(deviceDashboardSearch?.acknowledged_id.includes('__NULL__') && !deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__')) {
            searchString += `acknowledged_by=__NULL__`
        }else if(deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__') && deviceDashboardSearch?.acknowledged_id.includes('__NULL__')) {
            searchString += `acknowledged_by=ne:__NULL__;acknowledged_by=__NULL__;`
        }else if((deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__') && deviceDashboardSearch?.acknowledged_id.includes('__NULL__')) && deviceDashboardSearch.acknowledged_id_inverse === "true") {
            searchString += `acknowledged_by=__NULL__;acknowledged_by=ne:__NULL__;`
        }

        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;

        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: deviceDashboardSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            limit: currentParams.limit || '15', // Keep limit or set default
        };
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        setisSortSelected(false)
        dispatch(setDeviceAlertDashboardSearchApplied());
    };
    useEffect(() => {
        // Set isStateLoading to true if any of the loading states are true
        if (isFetching) {
            setIsStateLoading(true);
        } else {
            // Set isStateLoading to false only when all loading states are false
            setIsStateLoading(false);
        }
    }, [isFetching]);
 
    return (
        <div className={`bg-white rounded-lg p-5 ${!wellnessFetching&&wellnessDetails?.patientData?.vital_reading_count ==='-' ? 'h-customh20':'h-customh19'} mt-[24px] ${((wellnessFetching||(isFetching&&status!=="fulfilled"&&status!=="rejected"))||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?'mt-4':''} relative`}>
            <div className={`flex ${!wellnessFetching&&wellnessDetails?.patientData?.vital_reading_count ==='-' && 'mb-[20px]'} justify-between items-center`}>
                <>
                    <h1 className="text-xl font-normal text-[#000000] pb-1 ">Device Alerts</h1>
                    <div className='flex items-center mb-3'>
                        <button 
                            id='search-btn'
                            type='button'
                            onClick={() => handleSearchClick()}
                            className="ml-2.5 border border-[#972E4C] rounded-[15px] px-[11px] py-[11px] min-w-max">
                            <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" />
                        </button>
                        <span onClick={() => setHelpGuideModel(true)} className=' ml-2 cursor-pointer'>
                            <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                        </span>
                    </div>
                </> 
            </div>
            
            {((wellnessFetching||(isFetching&&status!=="fulfilled"&&status!=="rejected"))||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text={`Loading Device Alerts...`} classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center h-[87%] m-5 mt-[70px] ${isSideBar?'linked_providers_overlay' : 'opened_linked_providers_overlay'}`}/>: (data!==undefined && data?.historical_reading?.length > 0 ) ? <> 
                {!wellnessFetching&&wellnessDetails?.patientData?.vital_reading_count!=='-'&&(<><div><p className='text-[14px] leading-[20px] text-[#031624] font-normal mb-[16px]'>{`Current Readings Days = ${wellnessDetails?.patientData?.vital_reading_count}, ${wellnessDetails?.patientData?.vital_pending_days} Days left in cycle (Minimum ${wellnessDetails?.patientData?.vital_number_of_time_periods} in ${wellnessDetails?.patientData?.vital_time_period} )`}</p>
                </div></>)}  
                <div className="">
                    <BloodGlouseVitalTable
                        pageNumber={Number(searchParams.get('page_number')) || 1}
                        List={data}
                        handleSearchParams={handleSearchParams}
                        handleAcknowlegde={handleAcknowlegde}
                        reading_count={reading_count}
                    />
                </div>
                {data?.total_count>=15&&<div className="w-full px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-lg">
                    <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                    <div className="flex items-center">
                        <Limit
                            limit={limit}
                            setLimit={setLimit}
                            handleNoOfRowsClick={handleNoOfRowsClick}
                        />
                        <Pagination
                            TotalCount={parseInt(data?.total_count)}
                            totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                            handleOnClickPageNumber={handleOnClickPageNumber}
                            // limit={Number(searchParams.get('limit'))}
                            limit={parseInt(limit)}
                        />
                    </div>
                </div>}
            </>:<>
                {data?.historical_reading?.length===0 && (searchParams.get("start_date")!==null||searchParams.get("end_date")!==null) ?
                    <SearchEmptyScreen 
                        isPatient={true}
                        text={"That filter combination has no result. Please try different criteria"} 
                    />
                    : (data?.total_count === 0 && (searchParams.get('search') || searchParams.get('search_mode'))) ? (
                        <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                    ):(
                        data?.total_count===0?<Emptyscreenwithouttitle
                            title={"Device Alerts"}
                            FirstPTag={'No Device Alerts yet'}
                            customHeight={true}
                        />:((status==="rejected"||(data?.total_count!==0&&data?.historical_reading?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                    )
                }
            </>}
            {acknowledgeModal &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        // emptyField={emptyArea}
                        // setEmptyField={setEmptyArea}
                        // setTextAreaMsg={setTextAreaMsg}
                        // textAreaMsg={""}
                        handleOnCLickActivate={handleFinalAcknowledge}
                        handleClose={handleConformationClick}
                        tittle={`Acknowledge`}
                        message={`Are you sure you want to acknowledge this?`}
                        textMessage={true === false ? false : true}
                        buttonName={true && !loading ? "Acknowledge" : <span>{<Loader />}</span>}
                        // CancelButton={'No'}
                        disabled={loading}
                    />
                }
            />
            }
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
            {isSearchOpen &&
                <DeviceAlertDashboardSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled}
                />
            }
        </div>
            
          
    )
}
